export enum PermissionEnum {

}

export const PermissionParent = {


} as const;
